module.exports = __webpack_public_path__ + "img/step3-detail_top1.e18621f5.png";